import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-page-my-m30',
  templateUrl: './page-my-m30.component.html',
  styleUrls: ['./page-my-m30.component.scss']
})
export class PageMyM30Component implements OnInit {

  isActivePeriod = isActivePeriod()
  constructor() { }

  ngOnInit(): void {
  }

}

/** Február 1 és Július 31 között aktív, egyébként inaktív */
function isActivePeriod(): boolean {
    return true; // TODO: ideiglenes megoldás teszteléshez
    const now = new Date();
    const month = now.getMonth();
    return (month >= 1 && month <= 6); // Február (1) és Július (6) között aktív
  }

